"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _clean_svg_string = require("../helpers/clean_svg_string");

var _clean_svg_string2 = _interopRequireDefault(_clean_svg_string);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var raven = require("../legacy/helpers/raven_client").default;

/**
 * Logs all actions and states after they are dispatched.
 */

var placeAdobeIcon = function placeAdobeIcon(assetData, imgSize, imgType, icon) {
    var csInterface = new CSInterface(),
        tempSVGPath = csInterface.getSystemPath(SystemPath.USER_DATA) + "/com.thenounproject.nounPanel/",
        imagePath = "" + tempSVGPath + icon.term_slug + "_" + icon.id + "." + imgType,
        result = void 0;
    window.cep.fs.makedir(tempSVGPath);

    if (imgType === "svg") assetData = btoa(unescape(encodeURIComponent(assetData)));

    result = window.cep.fs.writeFile(imagePath, assetData, window.cep.encoding.Base64);

    if (0 == result.err) {
        var adobeAgent, script;
        script = "if (BridgeTalk.appName == 'photoshop') { var actDesc = new ActionDescriptor(); actDesc.putPath(charIDToTypeID('null'), new File(decodeURI('" + imagePath + "'))); actDesc.putEnumerated( charIDToTypeID('FTcs'), charIDToTypeID('QCSt'), charIDToTypeID('Qcsa')); executeAction(charIDToTypeID('Plc '), actDesc, DialogModes.NO); } else if(BridgeTalk.appName == 'illustrator') { var doc = app.activeDocument; var svgFile = new File('" + imagePath + "'); doc.groupItems.createFromFile(svgFile); var item = doc.pageItems[0];var imageSize = '" + imgSize + "'; if(item.width > item.height){var longerDimension = item.width }else{var longerDimension = item.height}; var scale = parseInt((imageSize / longerDimension * 100)); item.resize(scale,scale,true, true,true,true,scale,undefined); } else if(BridgeTalk.appName == 'indesign') { var userDefinedSize = " + imgSize + "; app.scriptPreferences.measurementUnit = MeasurementUnits.PIXELS; var page = app.activeWindow.activePage, pageWidth = page.bounds[3] - page.bounds[1], pageHeight = page.bounds[2] - page.bounds[0], containerFrame = page.rectangles.add(); if( userDefinedSize > pageWidth || userDefinedSize > pageHeight ){if( pageWidth > pageHeight ){ userDefinedSize = pageHeight; }else{ userDefinedSize = pageWidth; };}; var newX = (pageHeight / 2) - (userDefinedSize / 2), newY = (pageWidth / 2) - (userDefinedSize / 2); containerFrame.geometricBounds = [newX,newY,newX + userDefinedSize,newY + userDefinedSize];var pdfFile = File('" + imagePath + "'); containerFrame.place(pdfFile); containerFrame.graphics[0].itemLink.unlink(); containerFrame.fit(FitOptions.PROPORTIONALLY); }";
        csInterface.evalScript(script, function (r) {

            window.cep.fs.deleteFile(imagePath);
        });
    } else {}
};

var plugin = function plugin(store) {
    return function (next) {
        return function (action) {
            var imgSize = void 0,
                selectedColor = void 0;

            switch (action.type) {
                case "FETCH_PNG_DATA_SUCCESS" || "PLACE_ICON":
                    var active_icon = store.getState().icons.active_icon;
                    imgSize = parseInt(store.getState().icons.imgChoices.selectedSize);
                    selectedColor = store.getState().icons.selectedColor.hex.replace("#", "");

                    switch (action.type) {
                        case "FETCH_PNG_DATA_SUCCESS":
                            // for office plugins
                            // place icon in office once we've got the base64 encoded image from the api

                            var _assetData = action.response.encoded_png,
                                options = {
                                coercionType: Office.CoercionType.Image,
                                imageWidth: imgSize,
                                imageHeight: imgSize
                            };

                            Office.context.document.setSelectedDataAsync(_assetData, options, function (asyncResult) {
                                if (asyncResult.status !== "succeeded") {
                                    // make a raven error
                                    raven.captureException(new Error("office plugin did not place"), {
                                        extra: {
                                            hostInfo: window.sessionStorage["hostInfoValue"],
                                            error: asyncResult.error
                                        }
                                    });
                                }
                            });

                            break;
                        case "PLACE_ICON":
                            // for adobe plugin
                            // place the svg data (used by adobe)

                            _assetData = action.assetData;
                            placeAdobeIcon(_assetData, imgSize, "svg", action.icon);
                            break;
                    }
                    break;
                case "FETCH_PDF_DATA_SUCCESS":
                    var assetData = action.response.encoded_pdf;

                    selectedColor = store.getState().icons.selectedColor.hex.replace("#", "");

                    return placeAdobeIcon(assetData, action.imgSize, "pdf", action.icon);
                    break;
                case "PLACE_SVG_FROM_ICONLIST_SUCCESS":
                    // placeing icon from iconlist just fetchs svg data. It still needs to be cleaned and placed
                    imgSize = action.imgSize;
                    selectedColor = store.getState().icons.selectedColor.hex.replace("#", "");

                    var cleanedSVG = (0, _clean_svg_string2.default)(action.response, !action.selectedColor.hex ? "#000000" : action.selectedColor.hex, imgSize);

                    placeAdobeIcon(cleanedSVG, parseInt(imgSize), "svg", action.icon);
                    break;
                case "SET_ICON_COLOR_PALETTE":
                    // set local storage
                    if (window.localStorage) {
                        if (Array.isArray(action.color.customColors)) {
                            localStorage.setItem("customColorPalette", JSON.stringify(action.color.customColors));
                            localStorage.setItem("selectedColor", JSON.stringify(action.color.selectedColor));
                        } else {
                            localStorage.removeItem("customColorPalette");
                            localStorage.removeItem("selectedColor");
                        }

                        if (action.color.selectedColor === undefined) {
                            localStorage.removeItem("selectedColor");
                        }
                    }
                    break;
                case "GET_PNG_URL_SUCCESS":
                    // gsuite

                    var color = action.color,
                        query = void 0,
                        size = action.imgSize;

                    if (color !== undefined && size !== undefined) {
                        query = "?color=" + action.color + "&dimensions=" + action.imgSize;
                    } else if (color === undefined && size !== undefined) {
                        query = "?dimensions=" + action.imgSize;
                    } else if (color !== undefined && size === undefined) {
                        query = "?color=" + action.color + "&dimensions=200";
                    }

                    window.parent.postMessage({
                        action: "insertIcon",
                        url: "" + action.response.url + query
                    }, "*");
                    break;
            }

            return next(action);
        };
    };
};

exports.default = plugin;